import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default () => {
  let modules = document.querySelectorAll('.module');
  gsap.registerPlugin(ScrollTrigger);

  const animateFrom = function (elem, direction) {
    if (!elem.classList.contains('transition-done')) {
      direction = direction || 1;
      var x = 0,
        y = direction * 100;
      elem.style.transform = 'translate(' + x + '%, ' + y + '%)';
      if (elem.classList.contains('text-transition')) {
        elem.style.opacity = '0';
      }
      gsap.fromTo(
        elem,
        { x: x, y: y, autoAlpha: 0, scaleY: 1.1 },
        {
          delay:
            elem.dataset.delay !== null ? (elem.dataset.delay * 50) / 1000 : 0,
          // duration: elem.dataset.duration !== null ? parseInt(elem.dataset.duration) / 1000 : 1,
          duration: 1,
          x: 0,
          y: 0,
          scaleY: 1,
          autoAlpha: 1,
          ease: 'power4.inOut',
          overwrite: 'auto',
          stagger: 1,
          onComplete: function () {
            elem.classList.add('transition-done');
            let parent = elem.parentNode;
            parent.classList.add('transition-done');
          },
        }
      );
    }
  };

  const hide = function (elem) {
    var x = 0,
      y = 100;
    elem.style.transform = 'translate(' + x + '%, ' + y + '%)';
    gsap.set(elem, {
      x: x,
      y: y,
      scaleY: 1.1,
      autoAlpha: 0,
    });
  };

  const doTransitions = function () {
    let animations = document.querySelectorAll('.has-transition');

    Array.prototype.forEach.call(animations, function (elem, index) {
      let parent = elem.parentNode;
      parent.classList.add('transition-wrapper');
      if (
        elem.classList.contains('text-transition') &&
        !elem.classList.contains('transition-done')
      ) {
        hide(elem);
      }
      if (!elem.classList.contains('transition-done')) {
        ScrollTrigger.create({
          trigger: elem,
          onEnter: function () {
            animateFrom(elem);
          },
          // onEnterBack: function() { animateFrom(elem, -1) },
          // onLeave: function() {
          // 	if(elem.classList.contains('text-transition')) {
          // 		hide(elem);
          // 	}
          //  } // assure that the element is hidden when scrolled into view
        });
      }
    });
  };

  let animations = document.querySelectorAll('.has-transition');
  Array.prototype.forEach.call(animations, function (elem, index) {
    if (!elem.classList.contains('transition-done')) {
      hide(elem);
    }
  });

  doTransitions();
};
